import { AgentConfigurationResponse } from '@big-red-group/storefront-common-checkout'
import { DEFAULT_LANGUAGE } from './UrlHelper'
import { DefaultPageResponse } from '@/types'

export async function getAgentConfiguration(
  partnerCode: string,
  catalogueType = 'EXOZ'
): Promise<AgentConfigurationResponse> {
  const agentConfiguration = {
    catalogueType: catalogueType,
    language: DEFAULT_LANGUAGE, // TODO language
    partnerCode: partnerCode,
  }
  const query = new URLSearchParams(agentConfiguration)
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_LOKI_BASE_URL}/storefront-resources/agent-configuration?${query}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const result = await response.json()
    return result
  } catch (error) {
    throw new Error(`An error occurred retrieving agent configuration: ${error}`)
  }
}

let pageProps: any

export function setPageProps(data: any) {
  pageProps = data
}

export function getPageProps(): DefaultPageResponse {
  return pageProps
}
